import { render } from "./SchemaRelationTable.vue?vue&type=template&id=47f25451&scoped=true"
import script from "./SchemaRelationTable.vue?vue&type=script&lang=js"
export * from "./SchemaRelationTable.vue?vue&type=script&lang=js"

import "./SchemaRelationTable.vue?vue&type=style&index=0&id=47f25451&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-47f25451"

export default script